import { API_endpoints } from "../config";

export const deleteEmploy = async (login_id: number,profile_id: number ) => {
    try {
        const response = await fetch(API_endpoints.deleteEmploy, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ profile_id, login_id }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Aktualisieren von Mitarbeiter Daten.");
        }

        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error("Fehler beim Aktualisieren von Mitarbeiter Daten Anfrage:", error);
        throw error;
    }
};
